import { useState } from "react";
import { Phone, MessageCircle, X, Cpu, Sparkles } from "lucide-react";
import { SITE } from "@/lib/site";
import { cn } from "@/lib/utils";

export const FloatingButtons = () => {
  const [open, setOpen] = useState(null); // 'call' | 'whatsapp' | null

  const close = () => setOpen(null);

  const renderOptions = (mode) => {
    const { fibaro, interior } = SITE.contacts;
    const items = [
      { key: "fibaro", icon: Cpu, label: fibaro.label, value: mode === "call" ? fibaro.phone : `+${fibaro.whatsapp}`, action: mode === "call" ? `tel:${fibaro.phone.replace(/\s/g, "")}` : `https://wa.me/${fibaro.whatsapp}` },
      { key: "interior", icon: Sparkles, label: interior.label, value: mode === "call" ? interior.phone : `+${interior.whatsapp}`, action: mode === "call" ? `tel:${interior.phone.replace(/\s/g, "")}` : `https://wa.me/${interior.whatsapp}` },
    ];
    return items.map((it) => (
      <a
        key={it.key}
        href={it.action}
        target={mode === "whatsapp" ? "_blank" : undefined}
        rel={mode === "whatsapp" ? "noopener noreferrer" : undefined}
        data-testid={`float-${mode}-${it.key}`}
        onClick={close}
        className="group flex items-center gap-4 bg-white text-charcoal-900 hover:bg-gold transition-colors px-4 py-3 shadow-lg border border-charcoal-100"
      >
        <span className={cn(
          "h-9 w-9 inline-flex items-center justify-center shrink-0",
          mode === "call" ? "bg-gold text-charcoal-900 group-hover:bg-charcoal-900 group-hover:text-gold" : "bg-[#25D366] text-white"
        )}>
          <it.icon className="h-4 w-4" />
        </span>
        <span className="flex flex-col items-start leading-tight">
          <span className="text-[9px] uppercase tracking-[0.22em] text-charcoal-500 group-hover:text-charcoal-900">{it.label}</span>
          <span className="text-sm font-medium">{it.value}</span>
        </span>
      </a>
    ));
  };

  return (
    <div className="fixed right-4 md:right-6 bottom-6 z-40 flex flex-col items-end gap-3" data-testid="floating-buttons">
      {/* Expanded panel */}
      {open && (
        <div
          data-testid={`float-panel-${open}`}
          className="flex flex-col gap-2 animate-fade-up"
        >
          <div className="flex items-center justify-between bg-charcoal-900 text-white px-4 py-2 shadow-lg">
            <span className="text-[10px] uppercase tracking-[0.22em]">
              {open === "call" ? "Call Us" : "WhatsApp Us"}
            </span>
            <button
              onClick={close}
              data-testid="float-close"
              aria-label="Close"
              className="ml-3 text-white/70 hover:text-white"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          {renderOptions(open)}
        </div>
      )}

      {/* Trigger buttons */}
      <button
        onClick={() => setOpen(open === "whatsapp" ? null : "whatsapp")}
        data-testid="float-whatsapp"
        className="group h-14 w-14 inline-flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl hover:scale-105 transition-transform"
        aria-label="WhatsApp"
        style={{ height: 56, width: 56 }}
      >
        <MessageCircle className="h-6 w-6" />
      </button>
      <button
        onClick={() => setOpen(open === "call" ? null : "call")}
        data-testid="float-call"
        className="group h-14 w-14 inline-flex items-center justify-center rounded-full bg-gold text-charcoal-900 shadow-xl hover:scale-105 transition-transform"
        aria-label="Call"
        style={{ height: 56, width: 56 }}
      >
        <Phone className="h-5 w-5" />
      </button>
    </div>
  );
};
